import { Component, Input, OnInit } from '@angular/core';
import { ProductCollectionField } from 'src/app/interfaces/product-collections';
import { ProductCollectionService } from 'src/app/services/product-collection.service';

@Component({
  selector: 'app-new-report-historical-data',
  templateUrl: './historical-data.component.html',
  styleUrls: ['./historical-data.component.scss']
})
export class NewReportHistoricalDataComponent implements OnInit {
  @Input() toggleReportOption: any;

  selectAll: boolean = false;
  canGenerateReport: boolean = false;

  fields: ProductCollectionField[] = [
    {
      title: 'Signals',
      name: 'signals',
      type: 'checkbox',
      options: [
        {
          title: 'Bsr',
          name: 'BSR',
        },
        {
          title: 'Price',
          name: 'PRICE',
        },
        {
          title: 'Sales',
          name: 'SALES',
        },
      ]
    },
    {
      title: 'Date Range',
      name: 'dateRange',
      type: 'checkbox',
      options: [
        {
          title: 'Last 30 Days',
          name: 'LAST_THIRTY',
        },
        {
          title: 'Last 30 to 60 Days',
          name: 'THIRTY_TO_SIXTY',
        },
        {
          title: 'Last 60 to 90 Days',
          name: 'SIXTY_TO_NINETY',
        },
      ]
    },
  ];

  constructor(
    private productCollectionService: ProductCollectionService
  ) { }

  ngOnInit(): void {
    $(document).off('click', '.value-div:not(.disabled)');
    $(document).on('click', '.value-div:not(.disabled)', function () {
      const field = $(this).parents('.collapsible-field');
      field.toggleClass('opened');
      field.find('.collapsible-content').slideToggle();
    });
  }

  onChangeValue(field: ProductCollectionField, value: string = '') {
    if (this.selectAll) {
      this.selectAll = false;
    }
    if (field.type === 'checkbox') {
      field.value = field.options?.filter(option => option.checked).map(option => option.name).join(',');
      field.valueShow = field.options?.filter(option => option.checked).map(option => option.title).join(', ');
    } else if (field.type === 'radio') {
      field.value = value;
      field.valueShow = field.options?.find(option => option.name === value)?.title;
    }
    this.canGenerateReport = this.fields.filter(field => field.checked && field.value).length > 0;
  }

  getReportRequestParams(): { [key: string]: string } {
    const reportFieldsData: { [key: string]: string } = {};
    this.fields.filter(field => field.value).map(field => {
      reportFieldsData[field.name] = field.value || '';
    });
    return reportFieldsData;
  }
}
